import { render, staticRenderFns } from "./add_role.vue?vue&type=template&id=463a15b9&scoped=true&"
import script from "./add_role.vue?vue&type=script&lang=js&"
export * from "./add_role.vue?vue&type=script&lang=js&"
import style0 from "./add_role.vue?vue&type=style&index=0&id=463a15b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463a15b9",
  null
  
)

export default component.exports